// Derive known authority hostname from the CIAM authority URL so we don't need a separate env var.
// MSAL requires knownAuthorities for any non-standard (non-login.microsoftonline.com) authority.
const ciamAuthority = process.env.REACT_APP_CIAM_AUTHORITY || 'https://tifoxrcms.ciamlogin.com/';
const ciamKnownAuthority = ciamAuthority.replace(/^https?:\/\//, '').replace(/\/$/, '');

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CIAM_CLIENT_ID,
    authority: ciamAuthority,
    redirectUri: process.env.REACT_APP_CIAM_REDIRECT_URI ?? window.location.origin,
    knownAuthorities: [ciamKnownAuthority],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  // offline_access gives MSAL a refresh token so acquireTokenSilent works across sessions
  scopes: ['openid', 'profile', 'email', 'offline_access'],
};
